import { ImpressionModalityScope } from '../generated/graphql';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useCurrentCaseContext } from 'common/CurrentCase/CurrentCaseProvider';
import type { DefaultContext } from '@apollo/client';

type Options = {
  context?: DefaultContext;
};

export const useIsAutoImpressionAllowedForModality = ({ context }: Options = {}): boolean => {
  const { data } = useCurrentUser({ context });
  const impressionGeneratorSettings = data?.me?.reporterSettings?.impressionGenerator;
  const { currentCase } = useCurrentCaseContext();

  const modalityScope = impressionGeneratorSettings?.modalityScope;
  const modality = currentCase?.modality;

  if (modalityScope === ImpressionModalityScope.All) return true;

  return modality != null && (impressionGeneratorSettings?.modalities?.includes(modality) ?? false);
};
